import React from "react";
import Typography from "../../Typography/Typography";

interface Props {
    children: React.ReactNode;
}

const FormFieldError = ({ children }: Props) => (
    <Typography className="block" variant="meta" color="plum">
        {children}
    </Typography>
);

export default FormFieldError;
